// extracted by mini-css-extract-plugin
export default {"page":"Page_page__6SQfo","title":"Page_title__8ZW67"};